import { ComponentType } from 'react';
import { Navigate, Route } from 'react-router-dom';

import { CandidateLoginFeature } from './candidate-login';
import { EmployerLoginFeature } from './employer-login';
import { CandidateRegisterFeature } from './feature-candidate-register';
import { RAuthFeature } from './feature-r-auth';
import { TgAuthFeature } from './feature-tg-auth';
import { TgJobFeature } from './feature-tg-job';

type AuthRouteProps = {
   captchaKey: string | null;
};

export type AuthRoute = {
   path: string;
   Component: ComponentType<AuthRouteProps>;
};

export const AUTH_ROUTES: AuthRoute[] = [
   {
      path: '/auth/candidate-login',
      Component: CandidateLoginFeature,
   },
   {
      path: '/auth/employer-login',
      Component: EmployerLoginFeature,
   },
   {
      path: '/auth/candidate-register',
      Component: CandidateRegisterFeature,
   },
   {
      path: '/tg/auth',
      Component: TgAuthFeature,
   },
   {
      path: '/tg/job',
      Component: TgJobFeature,
   },
   {
      path: '/r',
      Component: RAuthFeature,
   },
   {
      path: '/r/:token',
      Component: RAuthFeature,
   },
];
